import { useContext } from "react";
import { receiptUploadContext } from "./receiptUpload.context";

export function useReceiptUpload() {
    return useContext(receiptUploadContext);
}
